import { Box, CircularProgress, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export default function LoadingIndicator() {
    const { t } = useTranslation();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 48px)' }}>
            <CircularProgress />
            <Typography sx={{ mt: 2, fontSize: 16, fontWeight: 'bold' }}>{t('loading...')}</Typography>
        </Box>
    );
}
